import { useSyncExternalStore } from "react";
import { getLanguageState, subscribeLanguage } from "./language";

export function useLanguage() {
  return useSyncExternalStore(
    subscribeLanguage,
    getLanguageState,
    getLanguageState,
  );
}
